import React, { useMemo, cloneElement, Children, isValidElement } from 'react';
import Link from '@mui/material/Link';
import { styled, useTheme } from '@mui/material';
import Typography from '../Typography';
import Paper from '../Paper';
const RootContainer = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));
const HeaderContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '24px',
  paddingBottom: '12px'
}));
const TitleContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'scroll'
}));
const BodyContainer = styled('div')(() => ({
  padding: '24px',
  paddingTop: '12px'
}));
const textOverflowStyleObj = {
  width: 'auto',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};
function useChildrenWithMargin(children, margin) {
  return useMemo(() => Children.map(children, child => {
    if (!margin) {
      return child;
    }
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(child, {
        style: {
          margin
        },
        margin
      });
    }
    return child;
  }), [children]);
}
export const InfoCard = _ref => {
  let {
    action,
    childrenSpacing,
    children,
    content,
    onClick,
    onClickContent,
    onClickHeader,
    onClickTitle,
    margin,
    title,
    titleURL,
    titleAdornment,
    titleColor = 'primary',
    titleVariant = 'h5',
    variant = 'default',
    ContainerSx,
    ContentContainerSx,
    HeaderContainerSx,
    TitleContainerSx
  } = _ref;
  const theme = useTheme();
  const childrenWithMargin = useChildrenWithMargin(children || content, childrenSpacing);
  return /*#__PURE__*/React.createElement(RootContainer, {
    onClick: onClick,
    sx: {
      backgroundColor: theme.palette.background[variant],
      margin,
      ...ContainerSx
    }
  }, (title || titleAdornment || action) && /*#__PURE__*/React.createElement(HeaderContainer, {
    onClick: onClickHeader,
    sx: HeaderContainerSx
  }, /*#__PURE__*/React.createElement(TitleContainer, {
    sx: TitleContainerSx
  }, titleURL ? /*#__PURE__*/React.createElement(Link, {
    href: titleURL,
    color: titleColor,
    variant: titleVariant,
    onClick: onClickTitle,
    sx: {
      ...textOverflowStyleObj,
      marginRight: titleAdornment && title ? '8px' : null
    }
  }, title) : /*#__PURE__*/React.createElement(Typography, {
    color: titleColor,
    variant: titleVariant,
    onClick: onClickTitle,
    sx: {
      ...textOverflowStyleObj,
      marginRight: titleAdornment && title ? '8px' : null
    }
  }, title), titleAdornment), action), /*#__PURE__*/React.createElement(BodyContainer, {
    onClick: onClickContent,
    sx: ContentContainerSx
  }, childrenWithMargin));
};
export default InfoCard;